document.addEventListener("DOMContentLoaded", function () {

  const text = document.getElementById("userText");
  const live = document.getElementById("liveText");
  const size = document.getElementById("size");
  const color = document.getElementById("color");
  const font = document.getElementById("font");


  if (!text || !live) return;


  // Scrittura testo + invio a Shopify
  text.addEventListener("input", function () {

    const value = this.value;

    // aggiorna anteprima
    live.innerHTML = value || "Il tuo testo";


    // salva valore per Shopify
    const productText = document.getElementById("productCustomText");

    if (productText) {
      productText.value = value;
    }

  });


  // Dimensione testo
  if (size) {
    size.addEventListener("input", function () {
      live.style.fontSize = this.value + "px";
    });
  }


  // Colore testo
  if (color) {
    color.addEventListener("input", function () {
      live.style.color = this.value;
    });
  }


  // Font
  if (font) {
    font.addEventListener("change", function () {
      live.style.fontFamily = this.value;
    });
  }


});